import {
    ImageBitmapLoader,
    LinearFilter,
    LinearMipmapLinearFilter,
    RepeatWrapping,
    SRGBColorSpace,
    Texture,
} from 'three';
import { logger } from '~/utils/logger';

export const loadBitmapTexture = (
    url,
    {
        flipY = false,
        minFilter = LinearMipmapLinearFilter,
        magFilter = LinearFilter,
        repeatWrapping = true,
    } = {}
) => {
    const loader = new ImageBitmapLoader();

    if (!flipY) loader.setOptions({ imageOrientation: 'flipY' });

    return new Promise((resolve, reject) => {
        loader.load(
            url,
            (imageBitmap) => {
                const texture = new Texture(imageBitmap);
                texture.colorSpace = SRGBColorSpace;
                texture.flipY = false;
                texture.minFilter = minFilter;
                texture.magFilter = magFilter;
                if (repeatWrapping) {
                    texture.wrapS = RepeatWrapping;
                    texture.wrapT = RepeatWrapping;
                }
                texture.needsUpdate = true;

                resolve(texture);
            },
            undefined,
            (err) => {
                // reject(err);

                logger.warn('Bitmap texture load failed', err);

                reject(err);
            }
        );
    });
};
